import React, { CSSProperties } from "react";
import { Timeline, Tween } from "react-gsap";
import { Controller, Scene } from "react-scrollmagic";
import styled from "styled-components";
import { IMangaInfo } from "../../model/MangaInfo";

export interface IMangaDisplayInfo {
	src: string;
	alt: string;
	needScroll: boolean;
	style: CSSProperties;
	parentStyle?: CSSProperties;
	from?: string;
	to?: string;
	duration?: number | string;
	alignHorizontal: boolean;
	info: IMangaInfo
}

export interface IMangaState {
	displayInfoList: IMangaDisplayInfo[],
	loaded: boolean,
	defaultHeight: number
}

export const DefaultMangaState: IMangaState = {
	displayInfoList: [],
	loaded: false,
	defaultHeight: -1
};

export const MangaHeaderParentDiv = styled.div`
	width: 100%;
	position: relative;
	background-color: white;
`;

export const MangaHeaderDiv = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
`;

export const MangaHeaderTitleH1 = styled.h1`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	font-family: nicomoji;
	width: 100%;
	opacity: 1;
`;

const MangaHeaderSpan = styled.span`
	font-size: 3.5vw;
	margin-top: 5vh;
`;

const MangaHeaderImg = styled.img`
	height: auto;
	margin: 3vh 0 2vh 0;
	object-fit: contain;
`;
const KomaDiv = styled.div`
	position: relative;
	text-align: center;
	display: flex;
	align-items: center;
	justify-content: center;

	span {
	  position: relative;
	  display: block;
	  overflow: visible;
	  top: 50%;
	  font-size: 80px;
	}
`;

const ComicDiv = styled.div`
  position: relative;
  height: 100vh;
  width: 100%;

  & .animation {
    width: 100%;
    height: 100%;
    position: absolute;
  }
`;

const BorderDiv = styled.div`
	  margin-top: 5vh;
	  height: 4px;
	  width: 98vw;
	  background-color: rgb(89, 87, 87);
`;

export const MangaHeader = React.memo( ( props: {
	triggerId: string,
	src: string,
	alt: string,
	message: string,
	imgStyle: CSSProperties,
	headerStyle?: CSSProperties
	headerSpanStyle?: CSSProperties,
	indicator?: boolean
} ) => {
	if ( props.triggerId.length < 1 ) {
		return <></>
	}

	return <MangaHeaderParentDiv>
		<MangaHeaderDiv
			style={{ ...props.headerStyle }}>
			<Controller>
				<Scene
					triggerHook={0.6}
					duration="90%"
					triggerElement={props.triggerId}
					classToggle={"visible"}
					indicators={props.indicator === true}
				>
					<BorderDiv/>
				</Scene>
				<Scene
					triggerHook={0.6}
					duration="100%"
					triggerElement={props.triggerId}
					classToggle={"visible"}
				>
					<MangaHeaderTitleH1>
						<MangaHeaderSpan
							style={{ ...props.headerSpanStyle }}
						>{props.message}</MangaHeaderSpan>
						<MangaHeaderImg
							style={{ ...props.imgStyle }}
							src={props.src}
							alt={props.alt}
						/>
					</MangaHeaderTitleH1>
				</Scene>
			</Controller>
		</MangaHeaderDiv>
	</MangaHeaderParentDiv>;
} );

/**
 * 紙芝居形式で表示
 * @param mangaState
 * @param className
 * @constructor
 */
export const StoryShow = React.memo( ( props: {
	mangaState: IMangaState,
	className: string,
	show: boolean
} ) => {
	if ( !props.mangaState.loaded ) {
		return <></>;
	}

	const aspectRatio = window.innerWidth / window.innerHeight;
	const controllerStyle = props.show ? undefined : { display: "none" };

	return <div style={controllerStyle} className={props.className}>
		<Controller>
			{props.mangaState.displayInfoList.map( (
				value: IMangaDisplayInfo,
				key: number
			) => {
				if ( !value.needScroll ) {

					const wipeClassName = aspectRatio > value.info.width / value.info.height ?
						"wipe-portrait " : "wipe-landscape ";

					return <Scene
						triggerHook="onLeave"
						pin
						key={key}
					>
						<KomaDiv className={wipeClassName}><img
							src={value.src}
							alt={value.alt}
							style={value.style}
						/></KomaDiv>
					</Scene>;
				}

				return <Scene
					triggerHook={"onLeave"}
					duration={value.duration}
					pin
					key={key}
				>
					{( progress: any ) => (
						<ComicDiv
							style={{ height: props.mangaState.defaultHeight + "px" }}
							className={"wipe"}>
							<Timeline totalProgress={progress} paused>
								<Tween
									from={{
										x: value.from,
										ease: "none"
									}}
									to={{
										x: value.to,
										ease: "none"
									}}
								>
									<div className="animation">
										<img
											src={value.src}
											alt={value.alt}
											style={value.style}
										/>
									</div>
								</Tween>
							</Timeline>
						</ComicDiv>
					)}
				</Scene>
			} )}
		</Controller>
	</div>;
} );
